import { useSEO } from "../lib/useSEO";
import { SectionLabel } from "../components/SectionLabel";

const COPY = {
  privacy: {
    label: "Legal",
    title: "PRIVACY POLICY",
    body: [
      "[Editable placeholder — replace with final legal copy]",
      "Queen Denae / Stunner Media and Entertainment respects your privacy. When you join the Royal List, we collect your first name and email address solely to send you updates about Royal Vault drops, new music, videos, events, and exclusive content.",
      "We do not sell or share your information with third parties. You can unsubscribe at any time using the link in any email, and your information will be removed from the list.",
      "Questions about this policy can be sent to the contact email listed in the footer.",
    ],
  },
  terms: {
    label: "Legal",
    title: "TERMS",
    body: [
      "[Editable placeholder — replace with final legal copy]",
      "All music, audio, video, imagery, and written content on QueenDenae.com — including everything in The Royal Vault — is the property of Queen Denae / Stunner Media and Entertainment and is provided for personal listening and viewing only.",
      "Royal Vault material lives here, in the archive, and is shared for personal listening. Please don't redistribute, re-upload, or republish it elsewhere — sharing the link is always the move.",
      "By using this site you agree to these terms.",
    ],
  },
};

export default function LegalPage({ kind }) {
  const c = COPY[kind] || COPY.privacy;
  useSEO(c.title, "Queen Denae legal information.");
  return (
    <div data-testid={`legal-${kind}`} className="pt-32 sm:pt-40 pb-24">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <SectionLabel>{c.label}</SectionLabel>
        <h1 className="font-serif text-4xl sm:text-6xl tracking-tight text-cream">{c.title}</h1>
        <div className="mt-10 space-y-5">
          {c.body.map((p, i) => (
            <p key={i} className={`leading-relaxed ${i === 0 ? "font-mono text-[11px] tracking-[0.2em] uppercase text-gold/60" : "text-sand"}`}>{p}</p>
          ))}
        </div>
      </div>
    </div>
  );
}
